<template lang="html">
  <div class="usluga">

  <div class="headUsluga">

    <router-link class="navbar-brand" to="/ksuslugeEng">Back </router-link>
    <h3>Assessment / Team Assessment</h3>
    <p>Team assessment provides information on the potentials, limitations and capacities of a team of employees, based on which team success can be predicted.</p>
    <p>This methodology provides insight into the competencies of candidates during the selection for a particular position within the organization, provides information on their strengths and weaknesses and allows comparison of candidates.</p>
    <p>It involves the use of psychological tests, tests of leadership skills, as well as intelligence tests, creating an assessment center for employee evaluation.</p>
    <p>The service is recommended for the assessment of management positions at all levels in the company</p>
    <h5>You need these services? Fill the form below:</h5>
      </div>
    <div class="card-body">



         <h4>Tests you are interested in</h4>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test1" value="Psihološki test">
           <label class="form-check-label" for="exampleCheck1">Psychological test</label>
         </div>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test2" value="Test liderskih sposobnosti">
           <label class="form-check-label" for="exampleCheck1">Leadership skills test</label>
         </div>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test3" value="Test inteligencije">
           <label class="form-check-label" for="exampleCheck1">Intelligence test</label>
         </div>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test4" value="Assessment centar">
           <label class="form-check-label" for="exampleCheck1">Assessment center</label>
         </div>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test5" value="Struktuirani Intervju">
           <label class="form-check-label" for="exampleCheck1">Structured Interview</label>
         </div>
         <div class="form-check">
           <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="test6" value="Test opštih i spacijalnih sposobnosti">
           <label class="form-check-label" for="exampleCheck1">Test of general and spatial abilities</label>
         </div>

         <div class="form-group">
           <label for="numberOfEmployees">Number of employees for whom the services are required</label>
           <input
             class="form-control"
             type="text"
             placeholder=""
             name="numberOfEmployees"
             v-model="numberOfEmployees"
             id="numberOfEmployees"
             >
         </div>
        <div class="form-group">
          <label for="companyName">Company name<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="companyName"
            v-model="companyName"
            id="companyName"
            >
        </div>
        <div class="form-group">
          <label for="contactName">Full name of contact person<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="contactName"
            v-model="contactName"
            id="contactName"
            >
        </div>
        <div class="form-group">
          <label for="contactNumber">Phone number<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="contactNumber"
            v-model="contactNumber"
            id="contactNumber"
            >
        </div>
        <div class="form-group">
          <label for="email">E-mail<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="email"
            v-model="email"
            id="email"
            >
        </div>



        <div class="validation">
          {{validation}}
        </div>
        <button class="btn btn-primary" @click="submit">Submit</button>
        &nbsp;&nbsp;&nbsp;&nbsp;



  </div>

  </div>


</template>

<script>
// eslint-disable-next-line no-unused-vars
import {mapActions,mapGetters} from 'vuex';
export default {

  name: 'AssessmentProcenaTimovaEng',
  data(){
    return{
      companyName:"",
  contactName:"",
  contactNumber:"",
  email:"",
  numberOfEmployees :"",
  validation:"",
  date:"",
    }
  },
  methods:{
  ...mapActions(['submitServiceAplication']),
  submit(){

    this.validation="";

    if(this.companyName==""){
      this.validation="Unesite naziv kompanije."
    }
    if(this.contactName==""){
      this.validation="Unesite ime i prezime kontakt osobe."
    }
    if(this.email==""){
      this.validation="Unesite email."
    }
    if(this.contactNumber==""){
      this.validation="Unesite kontakt telefon."
    }
    const d = new Date();
    let day = d.getDate();
    let month = d.getMonth()+1;
    let year = d.getFullYear();
    this.date= "Datum: "+day+"."+month+"."+year+".";


    let text = [];
    text.push("Assessment Procena Timova");
    text.push(this.date);
    text.push("Naziv Kompanije: "+this.companyName);
    text.push("Ime i Prezime Kontakt Osobe: "+this.contactName);
    text.push("Email: "+this.email);
    text.push("Kontakt telefon: "+this.contactNumber  );
    text.push("Broj zaposlenih u kompaniji: "+this.numberOfEmployees);
    let strTestovi="Testovi za koje ste zainteresovani: ";
    if(this.test1){
      strTestovi+="Psihološki test,"
    }
    if(this.test2){
      strTestovi+="Test liderskih sposobnosti,"
    }
    if(this.test3){
      strTestovi+="Test inteligencije,"
    }
    if(this.test4){
      strTestovi+="Assessment centar,"
    }
    if(this.test5){
      strTestovi+="Struktuirani Intervju,"
    }
    if(this.test6){
      strTestovi+="Test opštih i spacijalnih sposobnosti,"
    }
    text.push(strTestovi);

    let data ={
      formular:text
    }

    if(this.validation==""){
    this.submitServiceAplication(data);
    this.validation="Uspesno poslat formular."
    }

  },
},
  beforeCreate: function() {
        document.body.className = 'usluge';
  }
}
</script>

<style lang="css" scoped>
.usluga{
  position: absolute;
  top: auto;
  left: 10%;
  right: 10%;
  background-color: white;
  border-style: solid;
  border-color: black;
  border-width: medium;
  border-radius: 15px;
  margin-top: 15px;

}
.headUsluga{
  background-color: #77bbee;
  padding: 10px;
  border-top-left-radius:  10px;
  border-top-right-radius:  10px;
}
.card-body{
  background-color: #bbffff;
  border-bottom-left-radius:  10px;
  border-bottom-right-radius:  10px;
}
.validation{
  margin-top: 5px;
  background-color: #00aaaa;
}
</style>
